var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.96521,
    y: 0.878174,
    width: 37.2207,
    height: 37.2207,
    fill: "url(#pattern0_73_80)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_73_80",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_73_80",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_73_80",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaUlEQVR4nO3ay0kEQRiF0QYTUHSvCEZqKEZgHLqoDMQ8hCvjC0HFQXTqOn3OuhfFfFVM9U8vCwAAAAAAAAAAMFGS4yTXSc5mroPlKcZRkts8u09y7ofpiPFKlKIYohTGEGXCH/jIdu6SnO50gWuS7U7Ge5twJ7PXvZciRg8xiohRRIwiYhQRo4gYReJq2yNi9IgYPSJGj4jRI2L0iBg9IkaPiNEjYvSIGD0iRo+I0SNi9MiaYyQ5SHK5+V5p+X/fTeXl2Yq1/1aMq5ZdFifjLUZmR4kYH2JMixIxvoyx8ygR49sYO4uSNcfYSHLYcoPJmm9Tn+zKm5m7Mms/GU1RIkZPlIjREyVi9ESJGD1RIkZPlIjREyVi9ESJGD1RIkZVlAtv4H/oB/Omh6x9NlV4Urax37OpfxZliNETZYjRE2WI0RNliNETZYjRE2WI0RNliNETZYjRE2WI0TNmuTIOAQAAAAAAAGCZ6xFEa/nhIJ9GHwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/Done.3dd1cfb77b0d6b66cfa1e2f69103cdc7.svg";
export { ForwardRef as ReactComponent };